export default {
  name: 'ProcessPage',
  data: function () {
    return {
      cardsList: {}
    }
  },
  methods: {
    handleOnScroll: function () {
      let deletePos = null
      let size = 0
      for (let i in this.cardsList) {
        if (window.scrollY + window.innerHeight * 0.25 >= Number(i)) {
          deletePos = i
          this.cardsList[i].classList.toggle('animate', true)
        }

        size++
      }

      if (deletePos) {
        delete this.cardsList[deletePos]
      }

      if (size < 1) {
        window.removeEventListener('scroll', this.handleOnScroll)
      }
    },
    handleMounted: function () {
      let cardElements = document.querySelectorAll('.principles__card')
      let i = cardElements.length
      for (;i--;) {
        let parent = cardElements[i].offsetParent
        let posY = cardElements[i].offsetTop
        do {
          posY += parent.offsetTop
          parent = parent.offsetParent
        } while (parent)

        this.cardsList[posY] = cardElements[i]
      }

      window.addEventListener('scroll', this.handleOnScroll)
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.handleMounted()
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleOnScroll)
  }
}



// WEBPACK FOOTER //
// ./src/components/ProcessPage/ProcessPage.js